<template>
  <div>
    <el-drawer
      title=""
      :visible.sync="showMemberDrawer"
      :with-header="false"
      :modal="false"
      :wrapperClosable="false"
    >
      <div class="addDrawerTitle">
        {{ drawerTitle }}
      </div>
      <div class="classTitle">
        <i class="line"></i
        ><span>{{ $t(`authorization.member.basicInfo`) }}</span>
      </div>
      <el-form
        ref="userForm1"
        :model="userForm"
        class="searchForm"
        style="height: 390px"
        :rules="userFormRules"
      >
        <el-form-item
          v-for="(item, index) in filteredUserInfo"
          :key="index + item.prop"
          :label="$t(item.label)"
          :required="item.required"
          :prop="item.prop"
        >
          <el-input
            v-if="
              item.prop !== 'positionCodes' &&
              item.prop !== 'parentOrgCode' &&
              item.prop !== 'userId' &&
              item.prop !== 'userRole'
            "
            v-model="userForm[item.prop]"
            :placeholder="$t(item.placeholder)"
            clearable
            :disabled="item.disabled"
          >
          </el-input>
          <el-input
            v-if="item.prop == 'userId'"
            v-model="userForm.userId"
            :placeholder="$t(item.placeholder)"
            :disabled="drawerMode === 'edit'"
          >
          </el-input>
          <!-- 父级组织机构号 -->
          <el-input
            v-if="item.prop == 'parentOrgCode' && currentNode.id"
            v-model="userForm.parentOrgCode"
            :placeholder="$t(item.placeholder)"
            :disabled="true"
          >
          </el-input>
          <el-input
            v-if="item.prop == 'userRole'"
            v-model="userForm.userRole"
            :disabled="true"
          >
          </el-input>

          <el-select
            ref="select"
            v-if="item.prop == 'parentOrgCode' && !currentNode.id"
            v-model="userForm.parentOrgCode"
            :placeholder="$t(item.placeholder)"
            :disabled="item.disabled"
            clearable
            collapse-tags
          >
            <el-option
              :value="parentOrgCode"
              :label="parentOrgCode"
              style="height: 100%"
            >
              <el-tree
                :data="orgTreeData"
                :props="treeDefaultProps"
                node-key="id"
                default-expand-all
                ref="tree"
                highlight-current
                :expand-on-click-node="false"
                @node-click="nodeClick"
              >
                <template slot-scope="{ data }">
                  <span v-if="data.type != 'POSITION'">
                    <span>
                      <i
                        v-if="data.type == 'DEPARTMENT'"
                        class="iconfont icon-bumen treeIcon"
                      ></i>
                      <i
                        v-if="data.type == 'ORG'"
                        class="iconfont icon-jigou treeIcon"
                      ></i>
                      <!-- 岗位不显示，岗位在下面岗位的地方选 -->
                      <span class="treeText">{{ data.label }}</span>
                    </span>
                  </span>
                </template>
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form
        :model="userFormPosition"
        class="positionForm"
        style="height: 120px"
      >
        <el-form-item
          :key="formData.positionCodes.prop"
          :label="$t(formData.positionCodes.label)"
          :required="formData.positionCodes.required"
          :prop="formData.positionCodes.prop"
        >
          <el-select
            v-model="userFormPosition.positionCodes"
            :placeholder="$t(formData.positionCodes.placeholder)"
            id="selectorg"
            collapse-tags
          >
            <el-option
              :value="mineStatusValue"
              :label="mineStatusValue"
              style="height: 100%"
            >
              <el-tree
                ref="orgTree"
                :data="posTreeData"
                :props="treeDefaultProps"
                node-key="id"
                default-expand-all
                :expand-on-click-node="false"
                highlight-current
              >
                <template slot-scope="{ data }">
                  <span>
                    <span>
                      <el-checkbox
                        v-if="data.type !== 'ORG' && data.type !== 'DEPARTMENT'"
                        v-model="data.checked"
                        @change="checkNode(data)"
                      ></el-checkbox>
                      <svg-icon
                        v-if="data.type == 'ORG' || data.type == 'DEPARTMENT'"
                        iconClass="govIcon"
                      />
                      <svg-icon
                        v-if="data.type == 'POSITION'"
                        iconClass="peoIcon"
                      />
                      <span class="treeText">{{ data.label }}</span>
                    </span>
                  </span>
                </template>
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="classTitle">
        <i class="line"></i
        ><span>{{ $t(`authorization.member.loginInfo`) }}</span>
      </div>
      <el-form
        ref="loginForm1"
        :model="loginForm"
        class="searchForm"
        v-if="drawerMode !== 'connectResourceGroup'"
        style="height: 180px"
        :rules="loginFormRules"
      >
        <el-form-item
          v-for="(item, index) in filteredLoginInfo"
          :key="index + item.prop"
          :label="$t(item.label)"
          :required="item.required"
          :prop="item.prop"
          :disabled="item.disabled"
        >
          <el-input
            v-model="loginForm[item.prop]"
            :placeholder="$t(item.placeholder)"
            clearable
            v-if="
              item.prop !== 'effectiveDate' &&
              item.prop !== 'pwdExpDate' &&
              item.prop !== 'loginPwd' &&
              item.prop !== 'loginId'
            "
          >
          </el-input>
          <el-input
            v-if="item.prop == 'loginId'"
            v-model="loginForm.loginId"
            :placeholder="$t(item.placeholder)"
            :disabled="drawerMode === 'edit'"
          >
          </el-input>
          <el-input
            v-if="item.prop === 'loginPwd'"
            show-password
            value="*************"
            disabled
          >
            <template slot="suffix">
              <span style="margin-right: 5px">|</span>
              <el-button type="text" @click="showPasswordDialog"
                >{{passwordButtonText }}</el-button
              >
            </template>
          </el-input>
          <el-date-picker
            v-model="loginForm.effectiveDate"
            type="datetime"
            :placeholder="$t(`common.selectDate`)"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-if="item.prop == 'effectiveDate'"
            :picker-options="pickerOptionsStart"
          >
          </el-date-picker>
          <!-- 密码有效期改为天数设置，提交时转换为日期 -->
          <el-input
            v-if="item.prop == 'pwdExpDate'"
            v-model.number="loginForm.pwdExpDays"
            placeholder="请输入天数"
            clearable
          >
            <template slot="append">天</template>
          </el-input>
        </el-form-item>
        <div>
          <el-button type="primary" icon="el-icon-plus" @click="addPhoneRow" style="margin-top: 10px">
            {{ $t(`common.add`) + $t(`common.associatedPhone`) }}
          </el-button>
        </div>
        <el-table
          :data="phoneList"
          :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
          style="margin-top: 10px"
        >
          <el-table-column
            type="index"
            :label="$t('common.index')"
          ></el-table-column>
          <el-table-column prop="phone" :label="$t('login.phone')">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.phone"
                :placeholder="$t('common.pleaseInput') + $t('login.phone')"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.action')">
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click="delPhoneRow(scope.$index)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

          <el-button class="yesBtn" type="primary" @click="confirm()">{{
            $t(`common.confirm`)
          }}</el-button>
          <el-button class="noBtn" @click="setDrawer(false)">{{
            $t(`common.cancel`)
          }}</el-button>

      </el-form>
      <el-dialog
        :title="`${drawerMode === 'edit' ? '修改密码' : '设置密码'}`"
        :visible.sync="setDialogVisible"
        width="430px"
        :close-on-click-modal="false"
        :before-close="handleClose"
        append-to-body
      >
        <el-form
          :model="setForm"
          :rules="setFormrules"
          ref="setFormRef"
          label-width="120px"
          margin-bottom="0px"
        >
          <el-form-item label="输入密码" prop="password">
              <el-input
                v-model="setForm.password"
                :type="pwdType1"
                maxlength="20"
                minlength="8"
                autocomplete="new-password"
              >
                <i
                  slot="suffix"
                  class="el-icon-view"
                  @click="showPwd1"
                ></i>
              </el-input>
              <div class="pwdRuleTip">
                密码长度8-20位，必须包含大写字母、小写字母、数字和特殊字符
              </div>
          </el-form-item>

          <el-form-item label="再次输入密码" prop="newPassword">
              <el-input
                v-model="setForm.newPassword"
                :type="pwdType2"
                maxlength="20"
                minlength="8"
                autocomplete="new-password"
              >
                <i
                  slot="suffix"
                  class="el-icon-view"
                  @click="showPwd2"
                ></i>
              </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer">
          <el-button
            type="primary"
            @click="updatePassword('setFormRef')"
            >确 定</el-button
          >
          <el-button @click="closePasswordDialog">取 消</el-button>
        </span>
      </el-dialog>
    </el-drawer>
  </div>
</template>

<script>
import { getOrgTree, listBindLoginPhone } from "@/api/authorization";
export default {
  name: "LeftDrawer",
  props: {
    drawerTitle: {
      type: String,
      default: "",
    },
    showMemberDrawer: {
      type: Boolean,
      default: false,
    },
    drawerMode: {
      type: String,
      default: "add",
    },
    type: {
      type: String,
      default: "",
    },
    formData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    addoreditForm: {
      type: Object,
      default: () => {
        return {};
      },
    },
    treeData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    currentNode: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      setDialogVisible: false,
      loadSetBtn: false,
      pwdType1: "password",
      pwdType2: "password",
      setForm: {
        password: "",
        newPassword: "",
      },
      setFormrules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: this.validatePassword,
            trigger: "blur",
          },
        ],
        newPassword: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            validator: this.validatePassword,
            trigger: "blur",
          },
        ],
      },
      phoneList: [],
      submitPhoneList: [],
      fatherNode: {},
      allTree: [],
      true: true,
      userFormPosition: {},
      mineStatusValue: "",
      mineStatusValueList: [],
      orgTreeData: [],
      posTreeData: [],
      treeDefaultProps: {
        children: "childNode",
        label: "label",
      },
      loginFormRules: {},
      userFormRules: {},
      defaultProps: {
        children: "children",
        label: "label",
      },
      api: {},
      tableType: "",
      tableData: {},
      loginForm: {
        loginId: "",
        loginPwd: "",
        effectiveDate: "",
        pwdExpDate: "",
        pwdExpDays: 90,
      },
      userForm: {
        userId: "",
        userName: "",
        rootOrgCode: [],
        parentOrgCode: "",
        branchCode: "",
        userKind: "",
        contactNo: "",
        email: "",
      },
      parentOrgCode: "",
      positionForm: {},
      false: false,
      addClass: "",
      tableConfig: {
        form: {
          params: [
            {
              type: "input",
              model: "inputKey",
              placeholder: `common.inputKey`,
            },
          ],
          actions: [
            { type: "query", name: `common.query`, event: "query" },
            { type: "add", name: `common.add`, event: "addResourceGroup" },
            { type: "remove", name: `common.remove`, event: "remove" },
          ],
        },
        table: {
          selection: true,
          columns: [
            { prop: "name", label: `common.name` },
            { prop: "ID", label: `common.ID` },
            { prop: "email", label: `common.email` },
            { prop: "job", label: `common.position` },
            { prop: "status", label: `common.status` },
          ],
          action: {},
        },
      },
    };
  },
  watch: {
    orgTreeData() {
      this.$forceUpdate();
    },
    treeData(val, oldVal) {
      if (val.length > 0) {
        if (oldVal.length == 0) {
          this.$nextTick(function () {
            let currentId = this.treeData[0].id;
            this.$refs.tree.setCurrentKey(currentId);
          });
          this.nodeClick(this.treeData[0]);
        }
      }
    },
  },
  computed: {
    filteredUserInfo() {
    return this.formData.userInfo.filter(item => {
      return !(item.prop === 'userRole' && this.drawerMode !== 'edit');
    });
  },
    // 过滤掉隐藏的密码生效时间字段
    filteredLoginInfo() {
      return this.formData.loginInfo.filter(item => {
        return item.prop !== 'effectiveDate';
      });
    },
    passwordButtonText() {  
      return this.drawerMode === 'edit' ? '修改密码' : '设置密码';  
    }, 
    buttonAuth: function () {
      return this.$store.getters.auth.buttonAuth;
    },
    // 开始结束日期限制
    pickerOptionsStart() {
      return {
        disabledDate: (time) => {
          if (this.loginForm.pwdExpDate) {
            return (
              time.getTime() >
              new Date(this.loginForm.pwdExpDate).getTime() -
                1 * 24 * 60 * 60 * 1000
            );
          }
        },
      };
    },
    // 结束日期限制
    pickerOptionsEnd() {
      return {
        disabledDate: (time) => {
          if (this.loginForm.effectiveDate) {
            return (
              time.getTime() < Date.now() - 1 * 60 * 60 * 1000 ||
              time.getTime() <
                new Date(this.loginForm.effectiveDate).getTime() +
                  1 * 24 * 60 * 60 * 1000
            );
          }
        },
      };
    },
  },
  created() {
    this.queryOrgTree();
    this.userForm.rootOrgCode = this.$store.getters.user.org;
  },
  mounted() {
    this.$nextTick(() => {
      let drawerHeight =
        document.getElementsByClassName("el-drawer__body")[0].scrollHeight;
      let screenHeight = window.screen.height;
      if (drawerHeight > screenHeight) {
        //按钮固定在抽屉下方
        this.addClass = "fixedBottom";
      } else {
        this.addClass = "";
      }
    });
    this.submitPhoneList = [];
    if (this.addoreditForm.userInfo) {
      //编辑状态
      this.userForm = this.addoreditForm.userInfo;
      this.userFormPosition.positionCodes = this.addoreditForm.positionCodes;
      this.loginForm = this.addoreditForm.loginInfo;
      //编辑状态，将密码过期时间换算为天数（基于生效时间，无生效时间则用当前时间）
      if (this.loginForm.pwdExpDate) {
        let baseTime = this.loginForm.effectiveDate
          ? new Date(this.loginForm.effectiveDate).getTime()
          : Date.now();
        let days = Math.ceil(
          (new Date(this.loginForm.pwdExpDate).getTime() - baseTime) /
            (24 * 60 * 60 * 1000)
        );
        this.loginForm.pwdExpDays = days > 0 ? days : 0;
      } else {
        this.loginForm.pwdExpDays = 90;
      }
      listBindLoginPhone({
        org: this.addoreditForm.userInfo.rootOrgCode,
        loginId: this.addoreditForm.loginInfo.loginId,
        userId: this.addoreditForm.userInfo.userId,
      }).then((res) => {
        res.data.forEach((item) => {
          this.phoneList.push({ phone: item });
        });
      });
    } else {
      //新增状态，密码生效时间默认为当前时间，有效期天数默认90天
      this.loginForm.effectiveDate = this.formatDateTime(new Date());
      this.loginForm.pwdExpDays = 90;
    }
    let _this = this;
    this.userFormRules = Object.assign(
      {},
      (function () {
        let obj1 = {};
        _this.formData.userInfo.forEach((item) => {
          let obj = {};
          obj[item.prop] = [
            {
              required: item.required,
              message: _this.$t(`common.pleaseInput`),
              trigger: "blur",
            },
          ];
          Object.assign(obj1, obj);
        });
        return obj1;
      })()
    );
    this.loginFormRules = Object.assign(
      {},
      (function () {
        let obj1 = {};
        _this.formData.loginInfo.forEach((item) => {
          let obj = {};
          if(_this.drawerTitle === _this.$t(`authorization.member.editMemeberTitle`)){
            item.required = false;
          }else if(item.prop === "loginId" || item.prop === "loginPwd"){
            item.required = true;
          }
          obj[item.prop] = [
            {
              required: item.required,
              message: _this.$t(`common.pleaseInput`),
              trigger: "blur",
            },
          ];
          Object.assign(obj1, obj);
        });
        return obj1;
      })()
    );
  },
  methods: {
    //日期格式化为 yyyy-MM-dd HH:mm:ss
    formatDateTime(date) {
      const pad = (n) => (n < 10 ? "0" + n : n);
      return (
        date.getFullYear() +
        "-" +
        pad(date.getMonth() + 1) +
        "-" +
        pad(date.getDate()) +
        " " +
        pad(date.getHours()) +
        ":" +
        pad(date.getMinutes()) +
        ":" +
        pad(date.getSeconds())
      );
    },
    handleClose() {
      this.setDialogVisible = false;
    },
    showPwd1() {
      this.pwdType1 === "password"
        ? (this.pwdType1 = "")
        : (this.pwdType1 = "password");
      let e = document.getElementsByClassName("el-icon-view")[0];
      this.pwdType1 == ""
        ? e.setAttribute("style", "color: #409EFF;margin-right:10px")
        : e.setAttribute("style", "color: #c0c4cc;margin-right:10px");
    },
    showPwd2() {
      this.pwdType2 === "password"
        ? (this.pwdType2 = "")
        : (this.pwdType2 = "password");
      let e = document.getElementsByClassName("el-icon-view")[1];
      this.pwdType2 == ""
        ? e.setAttribute("style", "color: #409EFF;margin-right:10px")
        : e.setAttribute("style", "color: #c0c4cc;margin-right:10px");
    },
    updatePassword(formRef) {
      this.$refs[formRef].validate((valid) => {
        if (valid) {
          if (this.setForm.password != this.setForm.newPassword) {
            this.$message({
              type: "error",
              message: "两次输入密码不一致！",
            });
            return;
          }
          // 提交密码更新逻辑
          this.loadSetBtn = true;

          this.loginForm.loginPwd = this.setForm.newPasswrod;
          this.setDialogVisible = false;

        } else {
          this.$message.error("请检查输入的密码是否符合要求");
          return false;
        }
      });
    },
    validatePassword(rule, value, callback) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z\s])[\S]{8,20}$/;
      if (!regex.test(value)) {
        callback(new Error("密码长度8-20位，必须包含大写字母、小写字母、数字和特殊字符"));
      } else {
        callback();
      }
    },
    closePasswordDialog() {
      this.setDialogVisible = false;
    },
    showPasswordDialog() {
      this.setDialogVisible = true;
    },
    addPhoneRow() {
      this.phoneList.push({ phone: "" });
    },
    delPhoneRow(index) {
      this.phoneList.splice(index, 1);
    },
    findFatherNode(allArr, node1, aim) {
      allArr.forEach((obj) => {
        (obj.childNode || []).forEach((node) => {
          if (node.type == "POSITION") {
            if (node.details.positionCode == node1.positionCode) {
              this.fatherNode = obj;
            }
          } else {
            this.findFatherNode(obj.childNode || [], node1, aim);
          }
        });
      });
    },
    nodeClick(val) {
      this.parentOrgCode = val.orgCode;
      this.userForm.parentOrgCode = val.label;
      this.$refs.select[0].blur();
      this.userFormPosition.positionCodes = "";
      this.changeNode();
    },
    checkNode(data) {
      if (data.checked) {
        this.mineStatusValueList.push(Object.assign(data, data.detail));
      } else {
        this.mineStatusValueList.forEach((item, index) => {
          if (item.details.positionCode == data.details.positionCode) {
            this.mineStatusValueList.splice(index, 1);
            // this.userFormPosition.positionCodes.splice(index, 1);
          }
        });
      }
      let str = "";
      this.mineStatusValueList.forEach((item) => {
        str += item.details.positionCode;
        str += ",";
      });
      str = str.substring(0, str.length - 1);
      this.mineStatusValue = this.userFormPosition.positionCodes = str;
      this.$nextTick(() => {
        document.getElementById("selectorg").blur();
      });
    },
    handleCheckChange() {
      let res = this.$refs.tree.getCheckedNodes(true, true); //这里两个true，1. 是否只是叶子节点 2. 是否包含半选节点（就是使得选择的时候不包含父节点）
      let arrLabel = [];
      let arr = [];
      res.forEach((item) => {
        arrLabel.push(item.label);
        arr.push(item);
      });
      this.mineStatusValueList = arr;
      // this.mineStatus = arrLabel;
    },
    checkboxChanged(data) {
      if (data.checked) {
        //
      } else {
        //
      }
    },
    queryOrgTree() {
      getOrgTree().then((res) => {
        if (res.data) {
          this.allTree.push(...res.data);
          //处理组织树，去掉岗位
          let arr1 = [];
          this.filterPos(this.allTree, arr1);
          // this.allTree.forEach()
          this.orgTreeData.push(...arr1);
          this.$forceUpdate();
          if (this.currentNode.id) {
            //已经在组织页面选择了上级
            //如果选择的不是岗位
            if (this.currentNode.type != "POSITION") {
              this.userForm.parentOrgCode = this.currentNode.orgCode;
            } else {
              //将岗位的上级赋给他
              this.findFatherNode(this.allTree, this.currentNode);
              this.userForm.parentOrgCode = this.fatherNode.details.orgCode;
            }
          }
          if (this.currentNode.id) {
            //已经在组织页面选择了上级
            this.changeNode();
          } else if (this.userForm.parentOrgCode) {
            //编辑模式
            this.changeNode();
          }
        }
      });
    },
    filterPos(arr, arr2) {
      if (arr.length == 0) {
        return;
      }
      arr.forEach((item) => {
        if (item.type != "POSITION") {
          arr2.push({
            id: item.id,
            label: item.label,
            orgCode: item.details.orgCode,
            childNode: [],
          });
          this.filterPos(item.childNode, arr2[arr2.length - 1].childNode);
        }
      });
    },
    //select框值改变时候触发的事件
    // selectChange(e) {
    // console.log('999')
    // var arrNew = [];
    // var dataLength = this.mineStatusValueList.length;
    // var eleng = e.length;
    // for (let i = 0; i < dataLength; i++) {
    //   for (let j = 0; j < eleng; j++) {
    //     if (e[j] === this.mineStatusValueList[i].label) {
    //       arrNew.push(this.mineStatusValueList[i]);
    //     }
    //   }
    // }
    // this.$refs.orgTree.setCheckedNodes(arrNew); //设置勾选的值
    // console.log('222')
    // },
    // clickInput(prop){

    // },
    callBackAction(param) {
      if (param.event !== "handleSelectionChange") {
        this[param.event](param);
      }
    },
    changeNode() {
      //根据父机构选择岗位
      this.posTreeData = [];
      // this.userFormPosition.positionCodes=''
      this.findPosition(
        this.allTree,
        this.userForm.parentOrgCode,
        this.posTreeData
      );
      //如果this.userFormPosition.positionCodes有值，还需要勾选上
      if (this.userFormPosition.positionCodes) {
        let arr = this.userFormPosition.positionCodes.split(",");
        this.setChecked(this.posTreeData, arr);
      }
    },
    setChecked(oriArr, arr) {
      oriArr.forEach((item) => {
        if (arr.indexOf(item.details.positionCode) > -1) {
          item.checked = true;
        } else {
          this.setChecked(item.childNode || [], arr);
        }
      });
    },
    findPosition(arr, code, result) {
      arr.forEach((item) => {
        if (item.type != "POSITION" && item.details.orgCode == code) {
          result.push(item);
        } else {
          this.findPosition(item.childNode || [], code, result);
        }
      });
    },
    query() {
      
    },
    addResourceGroup() {
      this.$emit("addResourceGroup");
    },
    add() {},
    remove(items) {
      this.$emit("deleteResourceGroup", items.selectedItems);
    },
    setDrawer(v) {
      this.$emit("changeMemberDrawer", v);
    },
    checkPhone() {
      this.submitPhoneList = this.phoneList.map((res) => {
        return res.phone;
      });
      const reg = /^[1][3-9][0-9]{9}$/;
      for (let index in this.submitPhoneList) {
        if (
          this.submitPhoneList[index] == "" ||
          this.submitPhoneList[index] == null
        ) {
          this.$message({
            message: this.$t("common.pleaseInput") + this.$t("login.phone"),
            type: "error",
          });
          return false;
        }
        if (!reg.test(this.submitPhoneList[index])) {
          this.$message({
            message: this.$t("common.invalidPhone"),
            type: "error",
          });
          return false;
        }
      }
      // 判断是否有重复项
      if (
        [...new Set(this.submitPhoneList)].length ===
        this.submitPhoneList.length
      ) {
        this.loginForm.loginPhones = [...this.submitPhoneList];
        return true;
      } else {
        this.$message({
          message: this.$t("common.phoneRepeated"),
          type: "error",
        });
        return false;
      }
    },
    confirm() {
      this.$refs["userForm1"].validate((valid1) => {
        if (valid1) {          
          if(this.loadSetBtn){
            this.loginForm.loginPwd = this.setForm.newPassword;
          }else{
            this.loginForm.loginPwd = "";
          }
          this.$refs["loginForm1"].validate((valid2) => {
            if (valid2 && this.checkPhone()) {
              //提交前将有效期天数转换为密码过期日期（基于生效时间，无生效时间则用当前时间）
              let days = Number(this.loginForm.pwdExpDays);
              if (!days || days <= 0 || isNaN(days)) {
                this.$message({
                  type: "error",
                  message: "请输入正确的密码有效天数",
                });
                return;
              }
              let baseDate = this.loginForm.effectiveDate
                ? new Date(this.loginForm.effectiveDate)
                : new Date();
              baseDate.setDate(baseDate.getDate() + days);
              this.loginForm.pwdExpDate = this.formatDateTime(baseDate);
              this.$emit("addoredit", {
                loginInfo: this.loginForm,
                userInfo: this.userForm,
                positionCodes: this.userFormPosition.positionCodes,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bottomBtns {
  text-align: left;
  margin-top: 10px;
  // margin-left: 228px;
  /* text-align: center;
  margin-left:-20px;
  width: 675px;
  height:60px;
  line-height:60px;
  background-color: white; */
}
.titleName {
  // font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #343c6a;
  // letter-spacing: 0;
  font-weight: 400;
}
.line {
  display: inline-block;
  height: 18px;
  width: 2px;
  background: #303133;
  margin-right: 5px;
}
.classTitle {
  height: 32px;
  line-height: 32px;
  font-size: 18px;
  display: flex;
  align-items: center;
}
form {
  height: 100%;
  margin-bottom: 30px;
}
.addDrawerTitle {
  margin-bottom: 20px;
}
.pwdRuleTip {
  font-size: 12px;
  color: #909399;
  line-height: 18px;
  margin-top: 4px;
}
.fixedBottom {
  position: fixed;
  bottom: 0;
}
::v-deep .el-drawer__body {
  position: relative !important;
}
::v-deep .el-input__inner {
  background: #ffffff !important;
  border: 1px solid #dbdbdb !important;
  border-radius: 2px !important;
}
::v-deep .el-drawer__open .el-drawer.rtl {
  width: 660px !important;
}
::v-deep .el-checkbox:last-of-type {
  margin-right: 10px !important;
}
::v-deep .el-form-item__label {
  display: block !important;
  width: 270px;
  text-align: left !important;
}
::v-deep .positionForm .el-form-item__content {
  width: 600px !important;
}
::v-deep .positionForm .el-select {
  width: 100% !important;
}
::v-deep .el-select-dropdown__item {
  height: 100% !important;
}
::v-deep .el-drawer__body {
  padding-bottom: 50px !important;
}
::v-deep .el-drawer__open .el-form-item {
  margin-right: 20px !important;
}
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 270px !important;
}
::v-deep .el-select {
  width: 270px !important;
}
::v-deep .el-form-item {
  display: inline-block !important;
}
</style>
